import { FullStory, init } from '@fullstory/browser'
import { Customer } from 'domain/Customer'
import { User } from 'domain/User'

import { logError } from '../utils/logger'

interface IFullStoryAnalyticsService {
  readonly shouldRun: () => boolean
  readonly orgId: string
}

export class FullStoryAnalyticsService {
  private orgId: string
  private readonly shouldRun: () => boolean

  constructor(props: IFullStoryAnalyticsService) {
    this.orgId = props.orgId
    this.shouldRun = props.shouldRun

    try {
      // don't initialise if orgId was not provided
      if (this.orgId && this.orgId !== 'undefined' && this.orgId.trim().length > 0) {
        init({
          orgId: this.orgId,
        })
      }
    } catch (e) {
      if (e instanceof Error) {
        logError(e)
      }
    }
  }

  private getFullName(user: User) {
    const nameParts = [user.firstName, user.lastName].filter(Boolean).join(' ').trim()
    return nameParts || ''
  }

  init(customer: Customer, user: User, loggedInAsCustomer: boolean, tokenRequestedFrom: string) {
    if (!this.shouldRun) {
      return
    }
    try {
      FullStory('setIdentity', {
        uid: user._id,
        properties: {
          name: this.getFullName(user),
          email: user.email,
          emailDomain: user.email.split('@')[1],
          source: 'ship',
          customerId: customer._id,
          customerName: customer.name,
          userId: user._id,
          userLanguage: user.preferredLanguage,
          isDemoCustomer: customer.isDemo,
          segment: customer.segment || '',
          roles: user.roles ? user.roles.join(',') : '',
          enabledFeatures: customer.enabledFeatures ? customer.enabledFeatures.join(',') : '',
          tokenRequestedFrom,
          loggedInFromTms: loggedInAsCustomer,
          activeRegularStatus: customer.activeRegularStatus,
          screenDimensions: `${window.screen.width} x ${window.screen.height}`,
        },
      })
    } catch (e) {
      if (e instanceof Error) {
        logError(e)
      }
    }
  }

  reset = () => {
    if (!this.shouldRun) {
      return
    }

    FullStory('setIdentity', {
      anonymous: true,
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
  sendEvent(name: string, data: any = {}) {
    if (!this.shouldRun) {
      return
    }

    try {
      FullStory('trackEvent', {
        name,
        properties: data,
      })
    } catch (e) {
      if (e instanceof Error) {
        logError(e)
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
  update(updates: any) {
    if (!this.shouldRun) {
      return
    }

    FullStory('setProperties', {
      type: 'user',
      properties: updates,
    })
  }
}
